import React, { ComponentType, ReactNode, Suspense } from 'react';

function withSuspense<TProps extends object>(
    Component: NonNullable<ComponentType<TProps>>,
    fallback: ReactNode | string = ''
): NonNullable<ComponentType<TProps>> {
    return (props: TProps) => (
        <Suspense fallback={fallback}>
            <Component {...(props as TProps)} />
        </Suspense>
    );
}

export default withSuspense;
